// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6755 ? "premiumcarousel.637162dd" : chunkId) + "--" + {"6078":"54daa1a","6755":"2a0f0be","9610":"ef5a404"}[chunkId] + ".css";
};